import React from "react";
import { useMarketingCopy } from "./MarketingShell";
import workspaceCopy from "./productWorkspaceCopy.json";

export function PilotWorkspacePreview() {
  const { language } = useMarketingCopy();
  const copy = (workspaceCopy[language] ?? workspaceCopy.en).pilotView;
  return <section className="quant-wrap pilot-preview" id="pilot-workspace" aria-labelledby="pilot-preview-title">
    <div className="pilot-preview-heading"><div><p className="narrative-label">{copy.sample}</p><h2 id="pilot-preview-title">{copy.title}</h2></div><p>{copy.description}</p></div>
    <div className="pilot-console" aria-label={copy.sample}>
      <div className="pilot-console-top"><span><img src="/logo/logo.png" width="19" height="19" alt="" /> YouWo / {copy.goal}</span></div>
      <div className="pilot-console-grid">
        <aside className="pilot-console-rail">
          <div className="pilot-rail-block"><h3>{copy.context}</h3><ul>{copy.sources.map(source => <li key={source}><i aria-hidden="true" />{source}</li>)}</ul></div>
          <div className="pilot-rail-block"><h3>{copy.memory}</h3><p>{copy.memoryValue}</p></div>
        </aside>
        <div className="pilot-console-main">
          <div className="pilot-goal"><span>{copy.goal}</span><h3>{copy.goalValue}</h3></div>
          <div className="pilot-operations">
            <div><h3>{copy.experiments}</h3><ol>{copy.experimentRows.map(row => <li key={row.title}><span>{row.title}</span><small>{row.status}</small></li>)}</ol></div>
            <div className="pilot-daily"><h3>{copy.report}</h3><ul>{copy.reportRows.map(row => <li key={row}><span aria-hidden="true" />{row}</li>)}</ul></div>
          </div>
        </div>
      </div>
      <div className="pilot-console-bottom"><div><strong>{copy.agents}</strong><span>{copy.models.join(" · ")}</span></div><p>{copy.control}</p></div>
    </div>
    <p className="pilot-preview-note">{copy.review}</p>
  </section>;
}

export function LearnflowPreview() {
  const { language } = useMarketingCopy();
  const copy = (workspaceCopy[language] ?? workspaceCopy.en).learnflow;
  return <section className="quant-wrap product-learnflow" id="learnflow" aria-labelledby="learnflow-title">
    <div className="product-learnflow-copy"><p className="narrative-label">{copy.label}</p><h2 id="learnflow-title">Learnflow</h2><p>{copy.text}</p><ul>{copy.features.map(feature => <li key={feature}>{feature}</li>)}</ul><a className="quant-text-link" href="https://learnflow.youwo.ai/">{copy.cta}</a></div>
    <figure>
      <div className="product-learnflow-screen"><img src="/product/capture.png" width="1492" height="822" alt={copy.alt} loading="lazy" decoding="async" /></div>
      <figcaption>{copy.caption}</figcaption>
    </figure>
  </section>;
}
